import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import HeadSub from '../../../../components/comm/HeadSub';
import URL from '../../../../constants/url';
import style from './ExerciseRecordComplete.module.css';

import iconStamp from '../../../../images/common/stamp.svg';

const ExerciseRecordComplete = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { name = '운동', kcal = 0 } = location.state || {};

    return (
        <>
            <div id="sub-content">
                <div className="inner-wrap">
                    <div className={style.completeWrap}>
                        <div className={style.completeStamp}>
                            <img src={iconStamp} alt="" />
                        </div>
                        <p className={style.completeMsg}>
                            {name}로<br />
                            <strong>{kcal.toLocaleString()}kcal</strong> 소모했어요.<br />
                            너무 완벽해요 🔥
                        </p>
                    </div>
                </div>
            </div>
            <div className={style.bottomBar}>
                <button type="button" className={style.btnOutline} onClick={() => navigate(URL.EXERCISE_RECORD_ADD, { replace: true })}>
                    운동 추가하기
                </button>
                <button type="button" className={style.btnPrimary} onClick={() => navigate(-1)}>
                    확인
                </button>
            </div>
        </>
    );
};

export default ExerciseRecordComplete;